import { render, staticRenderFns } from "./RegistrationHeaderTab.vue?vue&type=template&id=7bcc6361&"
import script from "./RegistrationHeaderTab.vue?vue&type=script&lang=ts&"
export * from "./RegistrationHeaderTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports